import { Notification } from '@lib/graphql/__generated__/graphql'
import { TFunction } from '@translations/useTranslations'
import { NOTIFICATION_ACTIONS, parseNotificationText } from './utils'

export const emailNotifications = (t: TFunction) => ({
  [NOTIFICATION_ACTIONS.EMAIL_ACCOUNT_SHARED]: (data: Notification) => (
    <>
      {t('commentLogs.newEmailAccount')}{' '}
      <span className="font-semibold">
        {`"${parseNotificationText(data.emailAccount?.email)}"`}
      </span>{' '}
      {t('commentLogs.hasBeenSharedWithYou')}
    </>
  ),
})
